<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Source TPCD</h3>
    </template>
    <template slot="body">
      <div>
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="tpcdVO.tpcdName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="tpcdVO.tpcdDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="tpcdVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="tpcdVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  addTpcd,
  checkTpcdNameDuplication
} from "@/api/tpcd";

export default {
  components: {
    CommonModal,
  },
  props: ["upperControllerId"],
  data() {
    return {
      tpcdVO: {
        tpcdId: "",
        upperControllerId : "",
        tpcdName: "",
        tpcdDesc: "",
        useYn: "",
      },
      tpcd: "",
    };
  },
  methods: {
    async save() {
      console.log(this.upperControllerId);
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        this.tpcdVO.upperControllerId = this.upperControllerId;
        //tpcdName 중복확인
        const { data } = await checkTpcdNameDuplication(this.tpcdVO);
        this.tpcd = data.tpcd;
        if (this.tpcd == null || this.tpcd == "" || this.tpcd.length == 0) {
          try {
            const response = await addTpcd(this.tpcdVO);
            return response.data.status;
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
        }
      } else {
        return "alert.plzCheckAllValues";
      }
    },
    reset() {
      this.tpcdVO.tpcdId = "";
      this.tpcdVO.tpcdName = "";
      this.tpcdVO.tpcdDesc = "";
      this.tpcdVO.useYn = "Y";
    },
    // tpcdForm(upperId) {
    //   // const response = await fetchTpcdForm(upperId);
    //   this.tpcdVO.upperControllerId = upperId;
    //   this.tpcdVO.useYn = "Y";
    // },
  },
};
</script>

<style></style>
